export enum Language {
  EN = 'en',
  DE = 'de',
}

export interface SettingsState {
  language: Language
}
